import React, { useRef, useEffect } from 'react';
import { motion, useAnimation, useInView } from 'framer-motion';
import Header from '../components/Header';
import HeroSectionAbout from '../components/HeroSection_about';
import AboutSection from '../components/AboutSection';
import AboutB2Section from '../components/AboutB2Section';
import VisionMissionSection from '../components/VisionMissionSection';
import DesignTools from '../components/DesiginTools';
import Footer from '../components/Footer';

// Wrapper component for animated sections
const AnimatedSection = ({ children, delay = 0 }) => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, amount: 0.2 });
  const controls = useAnimation();

  useEffect(() => {
    if (isInView) {
      controls.start('visible');
    }
  }, [isInView, controls]);

  return (
    <motion.div
      ref={ref}
      initial="hidden"
      animate={controls}
      variants={{
        hidden: { opacity: 0, y: 50 },
        visible: { 
          opacity: 1, 
          y: 0,
          transition: { 
            duration: 0.0, 
            ease: "easeOut",
            delay: delay 
          }
        }
      }}
      style={{ width: '100%' }}
    >
      {children}
    </motion.div>
  );
};

const AboutPage = () => (
  <>
    <Header />
    <main style={{ width: '100%', overflow: 'hidden' }}>
      <AnimatedSection>
        <HeroSectionAbout />
      </AnimatedSection>
      

        <AboutSection />
 
      
      <AnimatedSection delay={0.1}>
        <AboutB2Section />
      </AnimatedSection>
      
      <AnimatedSection delay={0.1}>
        <VisionMissionSection />
      </AnimatedSection>
      
      <AnimatedSection delay={0.1}>
        <DesignTools />
      </AnimatedSection>
    </main>
    <Footer />
  </>
);

export default AboutPage;